export function getBrowserName(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Edg/')) {
    return 'Edge';
  }

  if (/OPR\/|Opera/.test(ua)) {
    return 'Opera';
  }

  if (ua.includes('Chrome/') && !/Edg|OPR/.test(ua)) {
    return 'Chrome';
  }

  if (ua.includes('Firefox/')) {
    return 'Firefox';
  }

  if (ua.includes('Safari/') && !/Chrome|Chromium|Edg|OPR/.test(ua)) {
    return 'Safari';
  }

  return 'Browser';
}
